var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.getLoadingStatus)?_c('div',[_c('Loader')],1):_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.async),expression:"async"}]},[_c('List')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }